import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },

  option: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '-1rem',

    '& .title': {
      '& > :last-child': {
        fontSize: theme.size.sm,
        opacity: '0.35'
      }
    }
  },
  btn: {
    transform: 'rotate(90deg)'
  }
}))

export default useStyles
